import classNames from 'classnames';
import type { FC } from 'react';

type Props = {
  text: string;
  extraText?: string;
  handleClick: () => void;
  isDisabled: boolean;
};

export const CouponButton: FC<Props> = ({ text, extraText, handleClick, isDisabled = false }) => {
  return (
    <div className="flex flex-col gap-2.5 items-center font-medium">
      <button
        disabled={isDisabled}
        className={classNames(
          'px-10 py-4 text-3xl rounded-full border-solid w-full focus:border-2 focus:border-solid ',
          'semiLg:px-15 semiLg:w-[390px] semiLg:max-w-[600px] semiLg:text-3.5xl',
          isDisabled
            ? 'border-none bg-gray500 text-white cursor-not-allowed'
            : 'border-2 bg-white text-primary border-primary'
        )}
        onClick={handleClick}
      >
        {text}
      </button>
      {extraText && <p>{extraText}</p>}
    </div>
  );
};
